var exports = {
  "w": "sidebarTooltip__Dvd9ZQ",
  "F": "sidebar-tooltip-appear__Gq9tTA",
};

module.exports = exports;
